module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-34-521a67a0f9a8a56648ea2332f9aeba42.svg";